<template>
    <v-data-table
            :headers="headers"
            :items="serviceList"
            sort-by="name"
            class="elevation-1"
            :options.sync="options"
            :server-items-length="serviceListTotal"
            @click:row="handleRowClick"
            :items-per-page="20"
            :footer-props="{
                            'items-per-page-options': [20, 50, -1]
                        }"
    >
        <template v-slot:top>
            <v-toolbar
                    flat
            >
                <v-text-field
                        v-model="filter.search"
                        :label="$vuetify.lang.t('$vuetify.page.Services.search')"
                        :hide-details="true"
                        class="mr-3"
                >
                </v-text-field>
                <v-select
                        dense
                        outlined
                        multiple
                        v-model="filter.status"
                        :items="serviceStatusList"
                        item-value="id"
                        item-text="name"
                        hide-details="auto"
                        :clearable="true"
                        :label="$vuetify.lang.t('$vuetify.page.Services.serviceTypeLabel')"
                        class="mr-3"
                ></v-select>
                <v-select
                        dense
                        outlined
                        multiple
                        v-model="filter.department"
                        :items="serviceDepartmentList"
                        item-value="id"
                        item-text="name"
                        hide-details="auto"
                        :clearable="true"
                        :label="$vuetify.lang.t('$vuetify.page.Services.serviceDepartment')"
                        class="mr-3"
                ></v-select>
                <v-select
                        dense
                        outlined
                        multiple
                        v-model="filter.executor"
                        :items="executorList"
                        item-value="id"
                        item-text="name"
                        hide-details="auto"
                        :clearable="true"
                        :label="$vuetify.lang.t('$vuetify.page.Services.executors')"
                        class="mr-3"
                ></v-select>
                <rl-datepicker
                        v-model="filter.datePeriod"
                ></rl-datepicker>
                <v-spacer></v-spacer>
<!--                <v-btn-->
<!--                        color="primary"-->
<!--                        dark-->
<!--                        class="mb-2"-->
<!--                        v-on:click="addService"-->
<!--                        v-if="canEditCard"-->
<!--                >-->
<!--                    {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}-->
<!--                </v-btn>-->
<!--                <v-dialog v-model="dialogDelete" max-width="500px">-->
<!--                    <v-card>-->
<!--                        <v-card-title class="headline">{{$vuetify.lang.t('$vuetify.page.all.deleteMsg')}}-->
<!--                        </v-card-title>-->
<!--                        <v-card-actions>-->
<!--                            <v-spacer></v-spacer>-->
<!--                            <v-btn color="blue darken-1" text @click="closeDelete">-->
<!--                                {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}-->
<!--                            </v-btn>-->
<!--                            <v-btn color="blue darken-1" text @click="deleteItemConfirm"-->
<!--                                   :loading="axiosLoading">-->
<!--                                {{$vuetify.lang.t('$vuetify.page.action.btnYes')}}-->
<!--                            </v-btn>-->
<!--                            <v-spacer></v-spacer>-->
<!--                        </v-card-actions>-->
<!--                    </v-card>-->
<!--                </v-dialog>-->
            </v-toolbar>
        </template>
        <template v-slot:item.serviceImportance.name="{ item }">
            <v-chip
                    :color="serviceImportanceColor(item.serviceImportance.id)"
                    dark
            >
                {{item.serviceImportance.name}}
            </v-chip>
        </template>
        <template v-slot:item.executors="{ item }">
            {{getExecutors(item)}}
        </template>
        <!--                    <template v-slot:item.actions="{ item }">-->
        <!--                        <v-icon-->
        <!--                                small-->
        <!--                                class="mr-2"-->
        <!--                                @click="openService(item.id)"-->
        <!--                        >-->
        <!--                            mdi-pencil-->
        <!--                        </v-icon>-->
        <!--                        <v-icon-->
        <!--                                small-->
        <!--                                @click="deleteItem(item)"-->
        <!--                        >-->
        <!--                            mdi-delete-->
        <!--                        </v-icon>-->
        <!--                    </template>-->
        <template v-slot:item.history.createdAt="{ item }">
            {{item.history.createdAt | formatDate}}
        </template>
        <template v-slot:no-data>
            Нет данных
        </template>
    </v-data-table>
</template>

<script>
    import _ from 'lodash';

    import {mapState} from 'vuex'
    import RlDatepicker from "@/view/dashboard/components/rl-datepicker";

    import {actionType, getterType} from "@/store/client/clientServices";

    export default {
        name: "ClientServices",
        components: {RlDatepicker},
        created() {
            this.$store.dispatch('retrieveServiceStatusDictionaryList')
            this.$store.dispatch('retrieveServiceImportanceDictList')
            this.$store.dispatch('retrieveDepartmentDictionaryList')
            this.$store.dispatch('retrieveExecutorDictionaryList')
            this.getServiceList()

            this.debouncedSearch = _.debounce(this.reloadData, 500)
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            serviceList() {
                return this.$store.getters[getterType.list]
            },
            serviceListTotal() {
                return this.$store.getters[getterType.listTotal]
            },
            serviceStatusList() {
                return this.$store.getters.serviceStatusDictionaryList
            },
            serviceImportanceList() {
                return this.$store.getters.serviceImportanceDictionaryList
            },
            serviceDepartmentList() {
                return this.$store.getters.departmentDictionaryList
            },
            executorList() {
                return this.$store.getters.executorDictionaryList
            },
            canEditCard() {
                return this.$store.getters.hasRole(['Administrator', 'ClientManager'])
            },
        },
        watch: {
            options: {
                handler() {
                    this.getServiceList()
                },
                deep: true,
            },
            'filter.search': {
                handler()
                {
                    this.debouncedSearch()
                }
            },
            'filter.status': {
                handler()
                {
                    this.reloadData()
                }
            },
            'filter.department': {
                handler() {
                    this.reloadData()
                },
            },
            'filter.datePeriod': {
                handler() {
                    this.reloadData()
                },
                deep: true
            },
            'filter.executor': {
                handler() {
                    this.reloadData()
                },
            },
        },
        data() {
            return {
                options: {},
                filter: {
                    search: null,
                    status: [],
                    department: [],
                    datePeriod: [
                        null,
                        null
                    ],
                    executor: []
                },
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.number'),
                        align: 'start',
                        sortable: true,
                        value: 'number',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.client'),
                        align: 'start',
                        sortable: true,
                        value: 'client.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceType'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceType.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceImportant'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceImportance.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceStatus'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceStatus.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.createDate'),
                        align: 'center',
                        sortable: true,
                        value: 'history.createdAt',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.executors'),
                        align: 'center',
                        sortable: true,
                        value: 'executors',
                    },
                    // {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
                ],
            }
        },
        methods: {
            reloadData(){
                if (this.options.page !== 1) {
                    this.options.page = 1
                } else {
                    this.getServiceList()
                }
            },
            getServiceList() {
                if (this.options.page) {
                    // this.generateQuery();
                    let itemPerPage = this.options.itemsPerPage === -1 ? null : this.options.itemsPerPage
                    let offset = itemPerPage ? (this.options.page - 1) * itemPerPage : null
                    let period = this.preparePeriod()
                    this.$store.dispatch(actionType.retrieveList, {
                        offset: offset,
                        limit: itemPerPage,
                        status: this.filter.status,
                        departmentId: this.filter.department,
                        fromDate: period[0],
                        toDate: period[1],
                        executorId: this.filter.executor,
                        search: this.filter.search,
                    })
                }
            },
            preparePeriod(){
                if(this.filter.datePeriod[0] === null){
                    return this.filter.datePeriod
                }

                let period = {...this.filter.datePeriod}

                if(!period[1]){
                    period[1] = period[0]
                }

                period[0] += 'T00:00:00'
                period[1] += 'T23:59:59'

                return period
            },
            openService(serviceId) {
                this._openServiceCard(serviceId)
            },
            _openServiceCard(serviceId) {
                let routeData = this.$router.resolve({
                    name: 'ServicesCard',
                    params: {
                        serviceId: serviceId
                    }});
                window.open(routeData.href, '_blank');
            },
            serviceImportanceColor(serviceImportanceId) {
                if (this.serviceImportanceList) {
                    return this.serviceImportanceList.find(item => item.id === serviceImportanceId).colorHex
                }
            },
            handleRowClick(row) {
                this._openServiceCard(row.id)
            },
            getExecutors(item) {
                let executorList = item.executors.map(i => {
                    return i.name
                })

                return executorList.join(', ')
            }
        }
    }
</script>

<style scoped lang="scss">
    .v-data-table ::v-deep table td{
        font-size: 1rem !important;
    }
</style>